import { defineMessages } from 'react-intl';
export const scope = 'utils.trnsactions';

export default defineMessages({
  cbi_interview: {
    id: `${scope}.cbi_interview`,
    defaultMessage: 'Intervju baziran na kompetencijama',
  },
  loop_selection: {
    id: `${scope}.loop_selection`,
    defaultMessage: 'Intervju baziran na kompetencijama',
  },
  tailor_made: {
    id: `${scope}.tailor_made`,
    defaultMessage: 'Prilagođeno rešenje',
  },
  standardised_interview: {
    id: `${scope}.standardised_interview`,
    defaultMessage: 'Selekcijski intervju',
  },

  custom_job: {
    id: `${scope}.custom_job`,
    defaultMessage: 'Personalizovani oglas',
  },
  template_job: {
    id: `${scope}.template_job`,
    defaultMessage: 'Loop obrazac ',
  },
  help_job: {
    id: `${scope}.help_job`,
    defaultMessage: 'Pomoć u kreiranju',
  },
  
});
